import Geofence from "../../../audi-ui-components/icons/Geofence";
import VoiceCall1 from "../../../audi-ui-components/icons/VoiceCall1";
import RatingStar from "./RatingStar";
import cn from "classnames";

const List = ({ locations, onClick = ()=>{}, className = "" }) => {

  const typeLabels = {
    "Sales": "Sales",
    "Service": "Service",
    "TradePartCentre": "Trade parts",
    "RepairCentre": "Approved repairer"
  };

  return (
    <ul className={cn("locate__list p-4", className)}>
      {locations.map((loc,i) => {
        return (
          <li key={`${loc.id}${i}`} className="locate__list-item p-3 mb-2" onClick={() => { onClick(loc); }}>
            <h5 className="mb-2">{loc.name} - {typeLabels[loc.type]}</h5>
            {loc.totalReviews > 0 && <p className="locate__rating mb-2">
              <span><RatingStar /> {loc.rating}</span> <span>{loc.totalReviews} reviews</span>
            </p>}
            <p className="locate__icon-line mb-2"><VoiceCall1 small /> <span>{loc.phone}</span></p>
            <p className="locate__icon-line mb-2">
              <Geofence small /> <span>{loc.address}, {loc.suburb} {loc.state} {loc.postcode}</span>
            </p>
          </li>
        );
      })}
    </ul>
  );
}

export default List;
